import Bar from '../components/charts/Bar';
import GeoChart from '../components/charts/GeoChart';
import ChartHeading from '../components/shared/ChartHeading';
import CustomCard from './PdfCustomCard';
import DashboardTable from '../components/shared/Table';
import TableHeading from '../components/shared/TableHeading';
import Pagination from '../components/shared/TablePagination';
import { useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { getChartData, getCityChart, getCompanyMapCountry, getCountryChart, getStateTableData, getStatsData } from '../services/adminService/adminService';
import PdfHeader from '../components/shared/PdfHeader';
import PdfFooter from '../components/shared/PdfFooter';
const PdfGeo = ({ selectedRange, showImage, selectedCampagins }) => {
    const userData = JSON.parse(localStorage.getItem('user'));
    const cityFranceMap = userData.cityFranceMap;
    const [companyId, setCompanyId] = useState(localStorage.getItem('selectedCompany'));
    const [selectedMap, setSelectedMap] = useState(cityFranceMap);
    const [zoom, setZoom] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [chartLoading, setChartLoading] = useState(true);
    const [pieChartLoading, setPieChartLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    // const[tableData,setTableDate]
    const [chartData, setChartData] = useState(null);
    const [pieChartData, setPieChartData] = useState(null);
    const [pieChartCountryData, setPieChartCountryData] = useState(null);
    const [pieChartPercentage, setPieChartPercentage] = useState(null);
    const [stats, setStats] = useState(null);
    const [ftdShow, setFtdSow] = useState();
    const [tableData, setTableData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const GeoHeading = [
        "Rank",
        "STATE",
        tableData?.length > 0 ? Object?.keys(tableData[0])[2] : "FTD’s (unique)",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[3]}` : "%FTD’s (unique)",
    ];
    const GeoHeading2 = [
        "Rank",
        "STATE",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[2]}` : "%FTD’s (unique)",
    ];
    const tableHeadings = () => {
        if (ftdShow) return GeoHeading;
        return GeoHeading2;
    };
    // const tableBody = tableData?.map((data) => [
    //     data?.Rank,
    //     data?.State,
    //     data?.FTDsUnique,
    //     `${data?.FTDsPercent}%`,
    // ]) || [];
    const tableBody = tableData?.map((data) => {
        const row = [
            data?.Rank,
            data?.State,
            ...(ftdShow ? [Object.values(data)[2]] : []),
            ...(ftdShow ? [`${Object?.values(data)[3]}%`] : [`${Object?.values(data)[2]}%`]),

            // `${Object.values(data)[2]}%`,
        ];
        return row.filter(value => value != null);
    }) || [];
    const dashboardCards = stats?.dynamicResults
        ? Object.entries(stats.dynamicResults)
            .filter(([label]) => label !== "Forecasted Budget")
            .map(([label, value]) => ({
                label: label,
                value: label === "Budget" || label === "Actual Budget"
                    ? `${new Intl.NumberFormat('fr-FR').format(value)} ${stats?.currency || ''}`
                    : `${new Intl.NumberFormat('fr-FR').format(value)}`,
            }))
        : [];
    const getStats = async (formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setLoading(true);
            const response = await getStatsData(formattedStartDate, formattedEndDate, companyId, selectedCampagins);
            setStats(response?.data?.data);
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }
    const getChart = async (formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setChartLoading(true);
            const response = await getChartData(formattedStartDate, formattedEndDate, companyId, selectedCampagins);
            setChartData(response?.data?.data);
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setChartLoading(false);
        } finally {
            setChartLoading(false);
        }
    }
    const getPieChartCountry = async (formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setPieChartLoading(true);
            const response = await getCountryChart(formattedStartDate, formattedEndDate, companyId, selectedCampagins);
            setPieChartCountryData(response?.data?.data?.dashboardPie);
            setPieChartPercentage(response?.data?.data?.percDiffer)

        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setPieChartLoading(false);
        } finally {
            setPieChartLoading(false);
        }
    }
    const getPiechartcity = async (formattedStartDate, formattedEndDate, selectedMap, selectedCampagins) => {
        try {
            setPieChartLoading(true);
            const response = await getCityChart(formattedStartDate, formattedEndDate, companyId, selectedMap, selectedCampagins);
            setPieChartData(response?.data?.data?.dashboardPie);
            setPieChartPercentage(response?.data?.data?.percDiffer)
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setPieChartLoading(false);
        } finally {
            setPieChartLoading(false);
        }
    }
    const getTable = async (page, formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setTableLoading(true);
            const response = await getStateTableData(formattedStartDate, formattedEndDate, page, 7, companyId, selectedCampagins);
            setTableData(response?.data?.data?.data);
            setTotalPages(response?.data?.data?.totalPages);
            setFtdSow(response?.data?.data?.ftdEnabled)
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setTableLoading(false);
        } finally {
            setTableLoading(false);
        }
    }
    const getCompanyMap = async () => {
        try {
            const response = await getCompanyMapCountry(companyId);
            console.log("Response country Map", response?.data?.cityFranceMap);
            setSelectedMap(response?.data?.cityFranceMap)
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }
    useEffect(() => {
        console.log("Company Id again", companyId)

        const handleCompanyChange = () => {
            setCompanyId(localStorage.getItem('selectedCompany'));
        };
        window.addEventListener('user-update', handleCompanyChange);

        return () => {
            window.removeEventListener('user-update', handleCompanyChange);
        };
    }, [companyId]);
    useEffect(() => {
        if (selectedRange && selectedRange?.length === 2) {
            setCurrentPage(1);
            const [startDate, endDate] = selectedRange;
            const formatLocalDate = (date) => {
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
            };
            const formattedStartDate = formatLocalDate(startDate);
            const formattedEndDate = formatLocalDate(endDate);
            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);
            getCompanyMap();
            getStats(formattedStartDate, formattedEndDate, selectedCampagins);
            getChart(formattedStartDate, formattedEndDate, selectedCampagins);
            getPieChartCountry(formattedStartDate, formattedEndDate, selectedCampagins);
            getPiechartcity(formattedStartDate, formattedEndDate, selectedMap, selectedCampagins);
        }
    }, [selectedRange, companyId, selectedCampagins]);
    useEffect(() => {
        if (selectedRange && selectedRange?.length === 2) {
            setCurrentPage(1);
            const [startDate, endDate] = selectedRange;
            const formatLocalDate = (date) => {
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
            };
            const formattedStartDate = formatLocalDate(startDate);
            const formattedEndDate = formatLocalDate(endDate);
            getPiechartcity(formattedStartDate, formattedEndDate, selectedMap);
        }
    }, [selectedRange, companyId, selectedMap]);
    useEffect(() => {
        if (selectedRange && selectedRange?.length === 2) {
            const [startDate, endDate] = selectedRange;
            const formatLocalDate = (date) => {
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
            };
            const formattedStartDate = formatLocalDate(startDate);
            const formattedEndDate = formatLocalDate(endDate);
            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);
            getTable(currentPage, formattedStartDate, formattedEndDate, selectedCampagins);
        }
    }, [selectedRange, currentPage, companyId, selectedCampagins]);
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const [currentData, setCurrentData] = useState([]);
    const [worldwide, setWorldwide] = useState(false);
    useEffect(() => {
        switch (selectedMap) {
            case 'worldwide':
                setCurrentData(pieChartCountryData);
                break;
            case 'FR':
                setCurrentData(pieChartData);
                // getPiechartcity(startDate, endDate, selectedMap);
                break;
            case 'US':
                setCurrentData(pieChartData);
                // getPiechartcity(startDate, endDate, selectedMap);
                break;
            case 'UK':
                setCurrentData(pieChartData);
                // getPiechartcity(startDate, endDate, selectedMap);
                break;
            default:
                setCurrentData(pieChartCountryData);
        }
        // eslint-disable-next-line
    }, [selectedMap, pieChartData, pieChartCountryData]);
    const handleResize = () => {
        if (mapRef.current) {
            mapRef.current.style.width = '100%';
            mapRef.current.style.height = '100%';
        }
    };
    const toggleView = () => {
        setZoom(0.8);
        handleResize();
    };

    const mapRef = useRef();
    return (
        <div id="pdf" className='pdf-size'>
            <div style={{
                backgroundImage: showImage
                    ? "url('https://res.cloudinary.com/djmk3gpgr/image/upload/v1730396033/skhbjvc4cy1zxtzudjvm.png')"
                    : "none",
                backgroundSize: 'cover',
                backgroundRepeat: "no-repeat",
                backgroundPosition: 'top center'
            }}
            >
                <PdfHeader showImage={showImage} />
                <Container className={` ${showImage ? 'px-5' : ''}`} fluid>
                    <CustomCard data={dashboardCards} stats={stats} loading={loading} />
                    <Row>
                        <Col xs={8} >
                            <div className='bg-white rounded-4 p-4 mt-4' style={{ height: "90%" }}>
                                <ChartHeading heading={"Performances"} />
                                <Bar height="95%" data={chartData} loading={chartLoading} />
                            </div>
                        </Col>
                        <Col xs={4}>
                            <div className='bg-white rounded-4 p-4 mt-4  ' style={{ height: "90%" }}>
                                <ChartHeading heading={"Performances"} />
                                <div className='my-3 mb-5'>
                                    <GeoChart mapRef={mapRef} handleResize={handleResize}
                                        currentData={currentData} worldwide={worldwide} toggleView={toggleView}
                                        loading={pieChartLoading}
                                        zoom={zoom}
                                        selectedMap={selectedMap}
                                        setSelectedMap={setSelectedMap}
                                        setZoom={setZoom}
                                        cityFranceMap={cityFranceMap}
                                        pieChartPercentage={pieChartPercentage}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className={`${showImage ? 'pb-5' : ''}`}>
                            <div className={`px-5 pt-3 bg-white rounded-4 m-1 ${showImage ? '' : ''}`}>
                                <div className='d-flex justify-content-between  align-items-center mb-5'>
                                    <TableHeading heading={"By Campaign"} />
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onNext={handleNext}
                                        onPrevious={handlePrevious}
                                    />
                                </div>
                                <DashboardTable
                                    tableBody={tableBody}
                                    tableHeadings={tableHeadings()}
                                    loading={tableLoading}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container >
            </div>
            <PdfFooter showImage={showImage} />
        </div>
    );
};

export default PdfGeo;
